import {parsePhoneNumberFromString, parseDigits} from "libphonenumber-js/max";

export function validateMobileNumber(item) {
    let phoneNumberField = $('#phone-number').find('#mobile-number');
    let countryCodeField = $('#phone-number').find('#phone-country-code');
    let errorBox = $('#phone-number').find('#pn');

    let number = parseDigits(phoneNumberField.val());
    phoneNumberField.val(number);
    let prefix = (countryCodeField.val() == '+01' ? '+1' : countryCodeField.val());
    let fullNumber = prefix+number;
    let validNumber = false;
    let validLineType = '';
    let acceptedTypes = ['MOBILE', 'FIXED_LINE_OR_MOBILE','undefined', 'PERSONAL_NUMBER'];

    // Validate phone number including country code
    const phoneNumber = parsePhoneNumberFromString(fullNumber);

    if (phoneNumber) {
        // Check if valid number has been supplied
        validNumber = phoneNumber.isValid();

        // Check type of supplied number
        validLineType = phoneNumber.getType();
    }

    if (!validNumber) {
        phoneNumberField.addClass('has-error').removeClass('is-ok');
        let message = "Invalid mobile number format";
        if (errorBox) {
            errorBox.html(message).show();
        }
        return false;
    } else if (!acceptedTypes.includes(validLineType)) {
        phoneNumberField.addClass('has-error').removeClass('is-ok');
        let message = "Only mobile numbers are allowed";
        if (errorBox) {
            errorBox.html(message).show();
        }
        return false;
    } else {
        phoneNumberField.addClass('is-ok').removeClass('has-error');
        if (errorBox) {
            if (errorBox.html() != 'The entered phone number is already in use') {
                errorBox.hide();
            }
        }
        return true;
    }
}

export default function mobileValidation() {
    $('#mobile-number').on('keyup', validateMobileNumber);
    $('#phone-country-code').on('change', validateMobileNumber);
};